import { useCartQuantity } from "@design-lab/features/manage-cart";
import { useEditMode } from "@design-lab/shared/hooks/useEditMode";
import { cn } from "@design-lab/shared/lib/tailwindcss";
import { ShoppingCart } from "lucide-react";

export function CartCounter() {
  const { isEditMode, assemblyGroupId } = useEditMode();
  const { data } = useCartQuantity(isEditMode ? assemblyGroupId : undefined);

  const size = data?.quantity && data.quantity > 99;
  const quantity = size ? "99+" : data?.quantity || 0;

  return (
    <a data-testid="cart-link" href="/cart" className="relative">
      <span
        className={cn(
          "text-background absolute -right-2.5 -top-2.5 flex size-5 items-center justify-center rounded-full bg-blue-700 text-[10px] font-bold lg:size-6 lg:text-xs",
          size && "size-6"
        )}
      >
        {quantity}
      </span>
      <ShoppingCart className="size-6 lg:size-8" />
    </a>
  );
}
